import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import routes from './routes';
import i18n from '../plugins/i18n';
import { localeCodes } from '../config/locales';

Vue.use(Router);
const router = new Router({
	mode: 'history',
	base: '/account/',
	routes,
	// when page transitioning, need to fix scroll position
	scrollBehavior: (to, from, savedPosition) => {
		if (to.hash) {
			return {
				selector: to.hash,
			};
		}
		return !savedPosition ? { x: 0, y: 0 } : savedPosition;
	},
});

function lazyLoadLocale(locale) {
	import(`../locale/${localeCodes[locale]}.json`)
		.then((msgs) => {
			i18n.setLocaleMessage(locale, msgs.default || msgs);
			i18n.locale = locale;
		})
		.catch(() => false);
}

function setRouteCookies(to) {
	const routeLang = to.params.locale,
		returnURL = to.query.return_url,
		prodId = to.query.prod_id,
		partnerKey = to.query.partnerkey || to.query.partner_key,
		cookieLang = Vue.cookie.get('i18next');

	if (!cookieLang && routeLang) {
		Vue.cookie.set('i18next', routeLang);
	}
	if (returnURL) {
		Vue.cookie.set('ReturnURL', returnURL);
	}
	if (prodId) {
		Vue.cookie.set('ProdId', prodId);
		store.commit('setProductId', prodId);
	}
	if (partnerKey) {
		Vue.cookie.set('partner_key', partnerKey);
		store.commit('setPartnerKey', partnerKey);
	}
}

router.beforeEach((to, from, next) => {
	const routeLang = to.params.locale,
		referrerUrl = document.referrer,
		appType = to.query.app_type,
		returnUrl = `${location.protocol}//${location.host}/account${to.fullPath}`;

	if (to.name) {
		document.body.className = to.name.toLowerCase();
	}
	if (referrerUrl) {
		// Store it if it's a nexon.com URL but NOT from the current site
		if (
			referrerUrl.indexOf('nexon.com') > 0 &&
			!new URL(referrerUrl).pathname.startsWith('/account/')
		) {
			store.commit('setReferrerUrl', referrerUrl);
		}
	}
	setRouteCookies(to);
	lazyLoadLocale(routeLang);

	if (appType) {
		store.commit('setAppType', appType);
	}

	if (to.matched.some((record) => record.meta.requireSettingsInfo)) {
		store.commit('setLoading', true);
		router.app.$accountAPI
			.get(`/account?_t=${Date.now()}`)
			.then(
				(response) => {
					if (!response.data.status) {
						store.commit('setSettingsData', response.data);
					}
					next();
				},
				(errorCode) => {
					console.log('router:', 'requireSettingsInfo', errorCode);
					next({
						name: 'login',
						query: {
							return_url: returnUrl,
						},
						params: to.params,
					});
				}
			)
			.finally(() => {
				store.commit('setLoading', false);
			});
		return;
	}

	if (to.matched.some((record) => record.meta.requiresLogin)) {
		store.commit('setLoading', true);
		router.app.$accountAPI
			.get(`/login/status?_t=${Date.now()}`)
			.then(
				() => {
					next();
				},
				(errorCode) => {
					console.log('router:', 'requiresLogin', errorCode);
					next({
						name: 'login',
						query: {
							return_url: returnUrl,
						},
						params: to.params,
					});
				}
			)
			.finally(() => {
				store.commit('setLoading', false);
			});
		return;
	}

	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js